<template>
    <div class="hotels">
<!--        <div class="form-item form-type-select">-->
<!--            <select name="country" v-model="country" @change="reloadBLazy()">-->
<!--                <option v-for="(value, key) in CountryOption" :selected="key === 0 ? 'selected' : ''"-->
<!--                        :value="key"-->
<!--                        :label="value"></option>-->
<!--            </select>-->
<!--        </div>-->

        <div class="tour-block-slider">
            <div class="slick-item-style" v-for="(value, key) in countryList[country]">
                <img class="b-lazy"
                     :src="value['data-src']"
                     :title="value['data-src']"
                     :alt="value['title']">
                <p class="title-offer" v-text="value['country']"></p>
                <div class="btn btn-success my-button button-order btn-find-tour-modal">
                    {{Lang.get('js.send_shares')}}
                </div>
            </div>
        </div>

<!--        <div class="centerAlign">-->
<!--            <ul class="offer_tour">-->
<!--                <li class="offerItem" v-for="(value, key) in countryList[country]">-->
<!--                    <div class="image">-->
<!--                        <img class="b-lazy" v-if="country === 0"-->
<!--                             src="/images/load.gif"-->
<!--                             :data-src="value['data-src']"-->
<!--                             :title="value['data-src']"-->
<!--                             :alt="value['title']">-->
<!--                        <img v-else-->
<!--                             :src="value['src']"-->
<!--                             :alt="value['title']">-->
<!--                        <div class="bl-disc" v-if="value['discount']">-->
<!--                            <p class="offer-discount" v-text="value['discount']"></p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <p class="title-offer" v-text="value['country']"></p>-->
<!--                    <p class="name" v-text="value['title']"></p>-->
<!--                    <p class="times" v-text="value['time']"></p>-->
<!--                    <div class="priceBlock">-->
<!--                        <div class="left"><p class="offer-price" v-html="value['price']"></p></div>-->
<!--                        <div class="right">-->
<!--                            <p class="form-order" title="Заказать"-->
<!--                               @click="orderHotel(value['country'],value['title'])">Заказать</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>

<script>
    export default {
        name: 'hotels-hot-tour',
        props: {},
        data() {
            return {
                CountryOption: {
                    0: 'Все страны',
                    1: 'Туреччина',
                    2: 'Египет',
                    3: 'Греция',
                    4: 'ОАЕ',
                    5: 'Болгария',
                    6: 'Доминикана',
                    7: 'Ізраїль',
                    8: 'Испания',
                    9: 'Кипр',
                    10: 'Мальдивы',
                    11: 'Таїланд',
                    12: 'Танзанія',
                    13: 'Тунис',
                    14: 'Шри-Ланка',

                },
                countryList: {
                    0: {
                        0: {
                            'discount': false,
                            'country': 'Туреччина',
                            'data-src': '/local-images/country/5_6.jpg',
                            'src': '/images/load.gif',
                            'title': 'Ramada Resort Side 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>392$</span>',
                        },

                        2: {
                            'discount': false,
                            'country': 'Таїланд',
                            'data-src': '/local-images/country/3_6.jpg',
                            'src': '/images/load.gif',
                            'title': 'Cookies Hotel 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>978$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Танзанія',
                            'data-src': '/local-images/country/4_7.jpg',
                            'src': '/images/load.gif',
                            'title': 'Warere Beach 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1005$</span>',
                        },
                        4: {
                            'discount': false,
                            'country': 'Єгипет',
                            'data-src': '/local-images/country/7.jpg',
                            'src': '/images/load.gif',
                            'title': 'Centara Grand Phratamnak Pattaya 5☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>987$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Болгарія',
                            'data-src': '/local-images/country/2_9.jpg',
                            'src': '/images/load.gif',
                            'title': 'Sea Park 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>461$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'data-src': '/local-images/country/4_3.jpg',
                            'src': '/images/load.gif',
                            'title': 'Marjan Island 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>447$</span>',
                        }, 7: {
                            'discount': false,
                            'country': 'Греція',
                            'data-src': '/local-images/country/6_3.jpg',
                            'src': '/images/load.gif',
                            'title': 'Holiday International 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>369$</span>',
                        },

                    },
                    1: {
                        0: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/1_8.jpg',
                            'title': 'Linda 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>258$</span>',
                        },
                        1: {
                            'discount': '-20%',
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/2_8.jpg',
                            'title': 'Seher Sun Palace Resort And Spa 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>258$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/5_6.jpg',
                            'title': 'Ramada Resort Side 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>392$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/6.jpg',
                            'title': 'Green Nature Resort & Spa 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>379$</span>',
                        },
                        4: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/7_7.jpg',
                            'title': 'Tac Premier Hotel & Spa 4☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>346$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/4_8.jpg',
                            'title': 'Sherwood Breezes Resort Hotel 5☆ питание UAL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>341$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/3_8.jpg',
                            'title': 'The Sense Deluxe 5*☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>283$</span>',
                        }, 7: {
                            'discount': false,
                            'country': 'Туреччина',
                            'src': '/local-images/country/turkey/8_8.jpg',
                            'title': 'Grand Nar Hotel 4☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>283$</span>',
                        },

                    },
                    2: {
                        0: {
                            'discount': false,
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/5_3.jpg',
                            'title': 'Sharming Inn Hotel 4☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>173$</span>',
                        },
                        1: {
                            'discount': '-20%',
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/6_5.jpg',
                            'title': 'Hawaii Riviera Aqua Park Resort 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>166$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/8_5.jpg',
                            'title': 'Grand Resort 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>206$</span>',
                        },
                        3: {
                            'discount': '-50%',
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/2_5.jpg',
                            'title': 'Caribbean World 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>273$</span>',
                        },
                        4: {
                            'discount': false,
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/3_5.jpg',
                            'title': 'Amwaj Oyoun 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>238$</span>',
                        },
                        5: {
                            'discount': '-75%',
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/1_5.jpg',
                            'title': 'The Movie Gate 4☆ питание UAI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>193$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/7_5.jpg',
                            'title': 'Amwaj Blue Beach Resort & SPA 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>186$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Египет',
                            'src': '/local-images/country/egypt/4_5.jpg',
                            'title': 'Sea Club 5☆ питание AI',
                            'time': 'от 7 ночей',
                            'price': 'от <span>334$</span>',
                        },

                    },
                    3: {
                        0: {
                            'discount': false,
                            'country': 'Греция',
                            'src': '/local-images/country/greece/3_13.jpg',
                            'title': 'Grecotel Mandola Rosa 5☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1443$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'Греция',
                            'src': '/local-images/country/greece/2_14.jpg',
                            'title': 'Faedra Beach 4☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>408$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Греция',
                            'src': '/local-images/country/greece/1.jpg',
                            'title': 'Triton Hotel Stalis 3☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>354$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Греция',
                            'src': '/local-images/country/greece/4.jpeg',
                            'title': 'Grecotel Eva Palace 5☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>2023$</span>',
                        },

                    },
                    4: {
                        0: {
                            'discount': '-25%',
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/8.jpg',
                            'title': 'Citymax Hotel Sharjah 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>249$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/5_1.jpg',
                            'title': 'Ras Al Khaimah Hotel 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>317$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/6_3.jpg',
                            'title': 'Holiday International 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>369$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/4_3.jpg',
                            'title': 'Marjan Island 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>447$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/3_3.jpg',
                            'title': 'Gloria Hotel Media City 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>519$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/7_3.jpg',
                            'title': 'Marjan Island Resort & Spa 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>471$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/8_3.jpg',
                            'title': 'Hilton Fujairah 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>449$</span>',
                        },
                        8: {
                            'discount': false,
                            'country': 'ОАЕ',
                            'src': '/local-images/country/oae/2_3.jpg',
                            'title': 'Ibis Hotel Fujairah 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>311$</span>',
                        },

                    },
                    5: {
                        0: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/bolgaria/4_10.jpg',
                            'title': 'Amira (Bansko) 5☆ питание НВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>570$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/bolgaria/1.jpeg',
                            'title': 'Maraya 3☆ питание НВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>397$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/bolgaria/3_10.jpg',
                            'title': 'Pamporovo 5☆ питание НВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>551$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/bolgaria/2_10.jpg',
                            'title': 'Finlandia 4☆ питание НВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>433$</span>',
                        },

                    },
                    6: {
                        0: {
                            'discount': '-25%',
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/1_1.jpg',
                            'title': 'Riu Naiboa 4☆ питание AI',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1723$</span>',
                        },
                        1: {
                            'discount': '-15%',
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/6_1.jpg',
                            'title': 'Be Live Experience Hamaca Garden 4☆ питание AL',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1278$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/69744460.jpg',
                            'title': 'Grand Bahia Principe La Romana 5☆ питание AL',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1544$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/2_1.jpg',
                            'title': 'Whala! Bavaro 3☆ питание AI',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1582$</span>',
                        },
                        4: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/3_1.jpg',
                            'title': 'Occidental Grand Punta Cana 4☆ питание AI',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1771$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/5_0.jpeg',
                            'title': 'Whala Bavaro Beach 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1165$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/7_1.jpg',
                            'title': 'Sivory Punta Cana Boutique Hotel 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1610$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Доминикана',
                            'src': '/local-images/country/dominican/4_1.jpg',
                            'title': 'Gran Bahia Principe Bavaro 5☆ питание AI',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1900$</span>',
                        },

                    },
                    7: {
                        0: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/israel/2_9.jpg',
                            'title': 'Sea Park 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>461$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/israel/1_0.png',
                            'title': 'Residence Netanya 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>391$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/israel/3_9.jpg',
                            'title': 'Leonardo City Tower Tel Aviv 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>871$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Болгария',
                            'src': '/local-images/country/israel/4_9.jpg',
                            'title': 'Leonardo Plaza Netanya Hotel 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>891$</span>',
                        },

                    },


                    8: {

                        0: {
                            'discount': false,
                            'country': 'Испания',
                            'src': '/local-images/country/spain/3.jpg',
                            'title': 'Gran Hotel Monterrey Leisure 5☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>704$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'Испания',
                            'src': '/local-images/country/spain/1_10.jpg',
                            'title': 'San Salvador 3☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>501$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Испания',
                            'src': '/local-images/country/spain/2_12.jpg',
                            'title': 'Aquarium & Spa 4☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>562$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Испания',
                            'src': '/local-images/country/spain/4_11.jpg',
                            'title': 'Gran Palas 5☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1036$</span>',
                        },

                    },

                    9: {

                        0: {
                            'discount': false,
                            'country': 'Кипр',
                            'src': '/local-images/country/kipr/3_12.jpg',
                            'title': 'Ajax Hotel 4☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>505$</span>',
                        },
                        1: {
                            'discount': false,
                            'country': 'Кипр',
                            'src': '/local-images/country/kipr/4_12.jpg',
                            'title': 'Napa Prince Aparthotel 3☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>484$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Кипр',
                            'src': '/local-images/country/kipr/2_13.jpg',
                            'title': 'Capital Coast Resort & Spa 4☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>565$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Кипр',
                            'src': '/local-images/country/kipr/1_11.jpg',
                            'title': 'Golden Bay 5☆ питание BB',
                            'time': 'от 7 ночей',
                            'price': 'от <span>957$</span>',
                        },

                    },

                    10: {

                        0: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/3_0.jpg',
                            'title': 'Holiday Island Resort 4☆ питание НВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1669$</span>',
                        },
                        1: {
                            'discount': '-35%',

                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/olhuveli_beach_spa_resort_5-e1481212196750.jpg',
                            'title': 'Olhuveli Beach & Spa Resort 5☆ питание FB',
                            'time': 'от 9 ночей',
                            'price': 'от <span>2045$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/5.jpg',
                            'title': 'Kaani Village & Spa 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1020$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/velnana.jpg',
                            'title': 'Velana Beach Maldives 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1139$</span>',
                        }, 4: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/7_0.jpg',
                            'title': 'Sun Island Resort & Spa 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1848$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/2_0.jpg',
                            'title': 'Ellaidhoo Maldives By Cinnamon 4☆ питание НВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1535$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/8_0.jpg',
                            'title': 'Amaya Resorts & Spas Kuda Rah 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>2325$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Мальдивы',
                            'src': '/local-images/country/maldivi/4_0.jpg',
                            'title': 'Paradise Island 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1765$</span>',
                        },

                    },
                   11: {

                        0: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/1_6.jpg',
                            'title': 'Crown Pattaya Bech 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>779$</span>',
                        },
                        1: {
                            'discount': false,

                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/8_6.jpg',
                            'title': 'Modus Resort Pattaya 5☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1002$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/4_6.jpg',
                            'title': 'Sea Sun Sand Resort & Spa 4☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1286$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/7.jpg',
                            'title': 'Centara Grand Phratamnak Pattaya 5☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>987$</span>',
                        }, 4: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/3_6.jpg',
                            'title': 'Cookies Hotel 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>978$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/5_4.jpg',
                            'title': 'Ambassador City Jomtien 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>781$</span>',
                        },
                        6: {
                            'discount': '-20%',
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/6_6.jpg',
                            'title': 'Aiyara Grand Hotel 4☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>831$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Таїланд',
                            'src': '/local-images/country/tailand/2_6.jpg',
                            'title': 'Centara Pattaya 4☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>844$</span>',
                        },

                    },

                    12: {

                        0: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/8_7.jpg',
                            'title': 'Kisiwa House 5*☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1313$</span>',
                        },
                        1: {
                            'discount': false,

                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/1_7.jpg',
                            'title': 'Sunset Kendwa 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>857$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/6_7.jpg',
                            'title': 'African Sun Sand Sea Resort & Spa 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>925$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/4_7.jpg',
                            'title': 'Warere Beach 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>1005$</span>',
                        },
                        4: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/5_5.jpg',
                            'title': 'Miramont Retreat Zanzibar 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>794$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/2_7.jpg',
                            'title': 'Amaan Bungalows☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>895$</span>',
                        },
                        6: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/6_6.jpg',
                            'title': 'Langi Langi Beach Bungalows 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>986$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Танзанія',
                            'src': '/local-images/country/tanzaniya/7_6.jpg',
                            'title': 'Zanzibar Queen Hotel 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>1156$</span>',
                        },

                    },

                    13: {
                      0: {
                            'discount': false,
                            'country': 'Тунис',
                            'src': '/local-images/country/tunis/3_11.jpg',
                            'title': 'Holiday Village Manar 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>493$</span>',
                        },
                        1: {
                            'discount': '-15%',

                            'country': 'Тунис',
                            'src': '/local-images/country/tunis/2_11.jpg',
                            'title': 'Delphin El Habib Resort 4☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>359$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Тунис',
                            'src': '/local-images/country/tunis/4.jpg',
                            'title': 'Medina Solaria & Thalasso 5☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span>500$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Тунис',
                            'src': '/local-images/country/tunis/1_9.jpg',
                            'title': 'Royal Jinene 4☆ питание AL',
                            'time': 'от 7 ночей',
                            'price': 'от <span> 318$</span>',
                        },
                    },

                    14: {

                        0: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/5_2.jpg',
                            'title': 'The Long Beach Resort 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>623$</span>',
                        },
                        1: {
                            'discount': false,

                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/6_4.jpg',
                            'title': 'Royal Castle Negombo 3☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>580$</span>',
                        },
                        2: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/1_4.jpg',
                            'title': 'Club Koggala Village 3☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>596$</span>',
                        },
                        3: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/4_4.jpg',
                            'title': 'Turyaa Kalutara 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>783$</span>',
                        },
                        5: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/3_4.jpg',
                            'title': 'Citrus Hikkaduwa 4☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>739$</span>',
                        },
                        6: {
                            'discount': false,

                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/8_4.jpg',
                            'title': 'Mount Lavinia Hotel 5☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>757$</span>',
                        },
                        7: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/7_4.jpg',
                            'title': 'Lavanga Resort & Spa 5☆ питание ВВ',
                            'time': 'от 9 ночей',
                            'price': 'от <span>828$</span>',
                        },
                        8: {
                            'discount': false,
                            'country': 'Шри-Ланка',
                            'src': '/local-images/country/shrilanka/2_4.jpg',
                            'title': 'Induruwa Beach 4☆ питание ВВ',
                            'time': 'от 7 ночей',
                            'price': 'от <span>626$</span>',
                        },
                    },


                },
                country: 0,
                Lang,
            }
        },
        methods: {
            reloadBLazy() {
                new Blazy({
                    breakpoints: [{
                        width: 420,
                        src: 'data-src-small'
                    }]
                });
            },
            orderHotel(country, resort) {
                window.modal.type = 'hotel_order';
                window.modal.country = country;
                window.modal.resort = resort;
                $('#main-modal').modal('show');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/HotelsHotTour.vue